module.exports = __webpack_public_path__ + "mainassets/img/bg1reverse.ac236020.svg";